import { PLOC } from "@/core/common/presentation/PLOC";
import DoLoginUseCase from "../domain/DoLoginUseCase";
import { Login } from "../domain/Login";
import { loginInitialState, LoginState } from "./LoginState";
import { DoLogoutUseCase } from "../domain/DoLogoutUseCase";

export class LoginPLOC extends PLOC<LoginState> {
  private login: Login;
  constructor(login: Login) {
    super(loginInitialState);
    this.login = login;
  }

  public async doLogin(captchaToken: string) {
    const loginResponse = await DoLoginUseCase.doLogin(this.login, this.state.mail, this.state.password, captchaToken);
    this.changeState({
      ...this.state,
      loginOk: loginResponse.success,
      loginErrorMsg: loginResponse.errorMsg,
      loggedUserId: loginResponse.userId,
      loginTried: true,
    });
  }

  public tryLoadLoggedUser() {
    const loggedUserId = DoLoginUseCase.tryLoadLoggedUser();
    if (loggedUserId)
      this.changeState({
        ...this.state,
        loggedUserId: loggedUserId,
        loginOk: true,
      });
  }

  public resetLoginInfo() {
    this.changeState({
      ...this.state,
      mail: "",
      password: "",
      loginOk: false,
      loginErrorMsg: "",
      loggedUserId: "",
      loginTried: false,
    });
  }

  public async doLogout() {
    const logoutOk = await DoLogoutUseCase.doLogout(this.login);
    if (logoutOk) this.resetLoginInfo();
  }
}
